import any from 'ramda/src/any';
import values from 'ramda/src/values';
import OrderState from '~/constants/orderState';
import createSelector from '~/store/createSelector';
import {
  getCtaButtonState,
  getHasCorePurchaseAndIsViewingReservable,
  getUser,
  getVehicleDetails
} from './index';

export const getConfirmModalCases = createSelector(
  [
    getUser,
    getHasCorePurchaseAndIsViewingReservable,
    getVehicleDetails,
    getCtaButtonState,
    (_, onlyConfirmCancellation: boolean) => onlyConfirmCancellation
  ],
  (
    { purchasing },
    hasCorePurchaseAndIsViewingReservable,
    { fuelDescription, transmission },
    { continuePurchase },
    onlyConfirmCancellation
  ) => {
    const hasPreOrder = purchasing?.orderState === OrderState.Reserved;
    const isManual = transmission?.toLowerCase().slice(0, 6) === 'manual';
    const isDiesel = fuelDescription?.toLowerCase().includes('diesel') ?? false;

    return {
      hasCorePurchaseAndIsViewingReservable,
      hasPreOrder,
      isManual: isManual && !continuePurchase && !onlyConfirmCancellation,
      isDiesel: isDiesel && !continuePurchase && !onlyConfirmCancellation
    };
  }
);

export const getShouldShowConfirmationModal = createSelector(
  getConfirmModalCases,
  confirmModalCases => any(val => Boolean(val))(values(confirmModalCases))
);
